var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[(_vm.src)?_c('img',{staticClass:"backgroundImg",attrs:{"src":_vm.src}}):_vm._e(),_c('div',{staticClass:"infoBubble"},[_c('img',{staticClass:"verifiedBadge",attrs:{"src":require('@/assets/badges/CareSend-verified-badge@2x.png')}}),_c('p',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }